// extracted by mini-css-extract-plugin
export default {"customSelect":"FormSelect_customSelect__i2Brf"};